import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
//import { theme } from "./styles/theme";
import { theme } from "../src/styles/theme"//
import {theme as mainTheme } from "@front-ends/common/src/styles/theme";

import App from "./App";
import {msalInstanceLinnae} from "./api/configs/Api"


// MSAL imports
import {
    EventType,
    EventMessage,
    AuthenticationResult,
} from "@azure/msal-browser";

msalInstanceLinnae.initialize().then(() => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstanceLinnae.getAllAccounts();
    if (accounts.length > 0) {
        msalInstanceLinnae.setActiveAccount(accounts[0]);
    }

    msalInstanceLinnae.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstanceLinnae.setActiveAccount(account);
        }
    });

    const root = createRoot(
        document.getElementById("root") as HTMLElement
    );
    root.render(
        <Router>
            <ThemeProvider theme={mainTheme}>
                <ThemeProvider theme={theme}>
                    <App pca={msalInstanceLinnae} />
                </ThemeProvider>
            </ThemeProvider>
        </Router>
    );
});
